import type { ComponentPropsWithoutRef } from "react";

import { cn } from "@/lib/cn";
import { FOCUS_ON_DARK, PRESS_FLAT } from "@/lib/interaction";
import { RISE_IN } from "@/lib/motion";

type SnackbarProps = {
  message: string;
  /** 되돌리기처럼 한 번 더 누를 기회를 주는 동작 */
  actionLabel?: string;
  onAction?: () => void;
} & Omit<ComponentPropsWithoutRef<"div">, "children">;

/**
 * 방금 일어난 일을 알리고 되돌릴 기회를 주는 막대.
 * 시안 02의 "3개를 조용한 방으로 옮겼어요 · 되돌리기".
 */
export function Snackbar({
  message,
  actionLabel,
  onAction,
  className,
  ...rest
}: SnackbarProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        // 방금 일어난 일을 알리는 것이라 밑에서 올라와야 "새로 생겼다"로 읽힌다.
        `flex items-center gap-3 rounded-xl bg-ink px-4 py-3 ${RISE_IN}`,
        className,
      )}
      {...rest}
    >
      <span className="flex-1 text-[13px] text-on-ink-2">{message}</span>

      {actionLabel ? (
        <button
          type="button"
          onClick={onAction}
          // 되돌릴 기회는 잠깐뿐이라 키보드로도 잡을 수 있어야 한다.
          className={`shrink-0 rounded border-b border-paper/50 text-[13px] font-semibold text-paper hover:border-paper active:text-on-ink-2 ${PRESS_FLAT} ${FOCUS_ON_DARK}`}
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
